export default __webpack_public_path__ + "static/media/9.1eeda5c0.jpg";